import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Navbar from './Navbar'
import { useMarkdownHtml } from '../utils/useMarkdownHtml'

const LEGAL_LINKS = [
  { to: '/terms', label: 'Terms of Use' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/acceptable-use', label: 'Acceptable Use Policy' },
]

// Renders one of the legal documents (markdown kept in /legal at the repo root) with links to the others.
export default function LegalPage({ markdown, title }: { markdown: string; title: string }) {
  const html = useMarkdownHtml(markdown)

  useEffect(() => {
    document.title = `${title} | I Got That U.S.`
  }, [title])

  return (
    <div className="min-h-screen flex flex-col bg-[var(--bg-primary)]">
      <Navbar />

      <main className="min-h-[calc(100vh-var(--navbar-height))]">
        <div className="container mx-auto px-4 py-6 max-w-4xl">
          <div className="mb-6 flex flex-wrap items-center justify-between gap-x-6 gap-y-1">
            <Link to="/" className="text-sm text-[var(--forest-green)] hover:underline min-h-[44px] inline-flex items-center">← Back to home</Link>
            <nav aria-label="Legal documents" className="flex flex-wrap gap-x-5">
              {LEGAL_LINKS.map((l) => (
                <Link key={l.to} to={l.to} aria-current={l.label === title ? 'page' : undefined} className={`text-sm min-h-[44px] inline-flex items-center hover:underline ${l.label === title ? 'font-semibold text-[var(--text-primary)]' : 'text-[var(--forest-green)]'}`}>{l.label}</Link>
              ))}
            </nav>
          </div>

          <article className="bg-white rounded-2xl border border-[var(--border)] shadow-sm p-6 sm:p-8 md:p-12">
            {html ? <div className="markdown-body" dangerouslySetInnerHTML={{ __html: html }} /> : <div className="text-[var(--text-secondary)]">Loading...</div>}
          </article>
        </div>
      </main>
    </div>
  )
}
